export * from './TamtamAPI/auth';
export * from './TamtamAPI/payment';
export * from './TamtamAPI/user';
export * from './TamtamAPI/apps'
export * from './TamtamAPI/statistics'
export * from './TamtamAPI/notifications';



// WEBPACK FOOTER //
// ./app/api/TamtamAPI.js